import React, { useState } from 'react'
import { Spinner, Col } from 'react-bootstrap'
import ConfirmationModal from '../../../common/modals/confirm'
import { deleteGift } from '../../../../services/giftService'
import { toast } from 'react-toastify'
import constants from '../../../../config/constants'
import { friendlyMessageFor } from '../../../../utility/errorHelper'
import { useHistory } from 'react-router-dom'

interface ButtonProps {
  isDisabled: boolean
  docId: string
}

const EditButtonGroup = ({ isDisabled, docId }: ButtonProps) => {
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  return (
    <>
      <>
        <ConfirmationModal
          show={showModal}
          body={'Delete this gift?'}
          isLoading={isLoading}
          onCancelClick={() => setShowModal(false)}
          onConfirmClick={() => {
            setIsLoading(true)
            deleteGift(docId)
              .then(result => {
                toast.success(constants.alertMessage.deleteGiftSuccessful, {
                  autoClose: 3000
                })

                if (result) {
                  history.push('/vendor/gifts')
                }
              })
              .catch(error => {
                toast.error(friendlyMessageFor(error), { autoClose: false })
                setShowModal(false)
              })
          }}
        />
      </>
      <Col xs={10} lg={6} className="pt-5 mx-lg-auto">
        <button
          className="btn btn-danger text-center mr-3"
          disabled={isDisabled}
          onClick={() => {
            setShowModal(true)
          }}
          type="button"
        >
          Delete gift
        </button>

        <button
          className="btn btn-primary text-center"
          disabled={isDisabled}
          data-testid="edit-submit"
          type="submit"
        >
          {isDisabled ? (
            <>
              <Spinner animation="border" size="sm" /> Save changes
            </>
          ) : (
            <>Save changes</>
          )}
        </button>
      </Col>
    </>
  )
}

export default EditButtonGroup
